import { Accordion } from '@hungryroot/pho';
import { Paragraph } from '@hungryroot/ramen';
import { segmentAnalytics } from '@hungryroot/segment';

import styles from './Faq.module.css';

const FAQS = [
  {
    title: 'What will I get in my first delivery?',
    content: `
    After you take our quiz and tell us what type of foods you like, we’ll suggest groceries and
    recipes we think you’ll love. You can take our suggestions, or choose from hundreds of top-rated
    groceries and recipes.
  `,
  },
  {
    title: 'How does Hungryroot save me $?',
    content: `
    The average Hungryroot customer saves $22+ each week on groceries. How? We source directly from
    the best brands, and—with over 3,000 chef-crafted recipes—help you make the most of your food each
    week. That means less food waste, fewer trips to the grocery store, and a very happy fridge.
  `,
  },
] as const;

function sendSegmentEvent(faqQuestion: (typeof FAQS)[number]['title']) {
  segmentAnalytics.track('sign_up_screen_faq', {
    context: {
      app: {
        name: 'Hungryroot Web',
        namespace: 'hungryroot.com',
      },
      faq_question: faqQuestion,
      sign_up_type: 'email',
      context_page_url: '/signup/',
    },
  });
  return true;
}

export function Faq() {
  return (
    <section className={styles.container}>
      {FAQS.map(({ title, content }) => {
        return (
          <Accordion
            key={title}
            className={styles.accordion}
            title={title}
            onToggle={() => {
              sendSegmentEvent(title);
            }}
          >
            <Paragraph>{content}</Paragraph>
          </Accordion>
        );
      })}
    </section>
  );
}
